import { 
  SET_CALCULATE_RESPONSE, 
  SET_SPINNER, 
  SET_SORTING_METHOD,
  RESET_CALCULATE_STATE,
  SET_WEB_CALCULATE_STATE, 
  SET_SCENE_SPINNER,
  SET_STEEL_TYPES,
  SET_REPORT_PROGRESS,
  SET_NAILS_SORTING_METHOD
} from './actions';
import { mergeDeep } from '@services/helper.service';

const initState = {
  grid: [],
  isWaiting: false,
  sortBy: null,
  isReverse: false,
  isGettingSnapshots: false,
  steelTypes: [],
  reportProgress: -1,
  nails: {
    sortBy: null,
    isReverse: false
  }
};

const calculate = (state = initState, action) => {
  switch (action.type) {
    case RESET_CALCULATE_STATE: {
      return initState;
    }
    case SET_WEB_CALCULATE_STATE: {
      return action.state;
    }
    case SET_CALCULATE_RESPONSE: {
      return mergeDeep({}, state, {
        grid: action.res
      });
    }
    case SET_SPINNER: {
      return mergeDeep({}, state, {
        isWaiting: action.isSpinning
      });
    }
    case SET_REPORT_PROGRESS: {
      return mergeDeep({}, state, {
        reportProgress: action.value
      });
    }
    case SET_SORTING_METHOD: {
      // if isReverse is not specified check the sort key
      let isReverse = action.isReverse !== null ? action.isReverse : (state.sortBy === action.sortBy ? !state.isReverse : false);
      return mergeDeep({}, state, {
        sortBy: action.sortBy,
        isReverse: isReverse
      });
    }
    case SET_NAILS_SORTING_METHOD: {
      // if isReverse is not specified check the sort key
      let isReverse = action.isReverse !== null ? 
        action.isReverse : (state.nails.sortBy === action.sortBy ? !state.nails.isReverse : false);
      return mergeDeep({}, state, {
        nails: {
          sortBy: action.sortBy,
          isReverse: isReverse
        }
      });
    }
    case SET_SCENE_SPINNER: {
      return mergeDeep({}, state, {
        isGettingSnapshots: action.value
      });
    }
    case SET_STEEL_TYPES: {
      return mergeDeep({}, state, {
        steelTypes: action.value
      });
    }
    default: {
      return state;
    }
  }
};

export default calculate;



// WEBPACK FOOTER //
// ./src/reducers/web-services/calculate/index.js